import OutfitFilters from '../../components/filters/outfit-filters.vue';

export default {
    path:'/outfit/filters',
    component: OutfitFilters,
    meta: {
        requiresAuth: true,
        hideHeaderButtons: true,
    },
}